import { Injectable } from '@angular/core'
import { TmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { ODataService, TransformationService } from 'common-services'

export interface IClaimLineExport extends IModelBase {
  EdiFileRevisionId: number
  ParentId: string
  ParentQualifier: string
  SegmentId: string
  Qualifier: string
  ElementId: number
  OldEdiFileSegmentInformationId: number
  OldValue: string
  NewEdiFileSegmentInformationId: number
  NewValue: string
  CreatedByIdentity: string
  CreatedOnDateTime: Date
}

@Injectable()
export class ClaimLineExportTransformationService extends TransformationService<IClaimLineExport> {
  constructor() {
    super()
  }

  responseTransformArray(response: any, method: string): IClaimLineExport[] {
    response = response.map((x, i) => {
      x.Id = `${x.ClaimDocumentId}|${x.ClaimLineId}|${x.ServiceLineId}|${x.FieldName}|${i}`
      return x
    })
    return response
  }
}

@Injectable()
export class ClaimLineExportODataService extends ODataService<IClaimLineExport> {
  constructor(
    protected http: HttpClient,
    protected config: TmODataConfiguration,
    protected idTransformService: ClaimLineExportTransformationService
  ) {
    super(http, config, idTransformService)
    this.typeName = 'ExportComparisonView'
  }
}
